import React, { Component } from 'react';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import Autocomplete from 'react-autocomplete';
import FIELDS from '../../data/fields';
import { createProductTelecom, updateProductTelecom } from '../../app/store/actions/productTelecom';
import ProductsAction from '../../app/store/actions/products';
import { getTypeSolutionOptions } from '../../app/store/actions/typeSolution';
import { getCableCategoryOptions } from '../../app/store/actions/cableCategory';
import { getTypeCoatingOptions } from '../../app/store/actions/typeCoating';
import ModalComponent from '../modal';

let selectedHelper = '';

class ProductTelecomForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: null,
      editProductTelecom: false,
      isLoading: false,
      isComponentMount: true,
      products: '',
      showModal: false,
      product: {
        soneparId: '',
        code: '',
      },
      listTypeSolutions: [],
      typeSolutions: '',
      typeSolutionId: '',      
      listTypeCoatings: [],
      typeCoatings: '',
      typeCoatingId: '',
      listCableCategories: [],
      cableCategories: '',
      cableCategoryId: '',
      formula: [],
      messageError: '',
      messageSuccess: '',
    };
  }

  setValue = (att, value) => {
    if (value && value < 0) {
      this.setState({ [att]: Math.abs(value) });
    } else {
      this.setState({ [att]: value });
    }
  }

  goBack = () => {
    this.props.back.goBack();
  };

  createProductTelecom = async () => {
    this.setState({ isLoading: true });
    const {
      product,
      typeSolutionId,
      typeCoatingId,
      cableCategoryId,
      formula,
    } = this.state;

    if (!product.soneparId || !formula.length) {
      this.setState({ messageError: I18n.t('fieldsNotReported') });
      this.setState({ isLoading: false });
      return;
    }

    try {
      await this.props.createProductTelecom({
        productId: product.soneparId,
        typeSolutionId,
        typeCoatingId,
        cableCategoryId,
        formula,
      });

      await this.setState({ messageSuccess: I18n.t('registrationPerformed') });
      await this.goBack();
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;
      this.setState({ messageSuccess: '' });

      if (error && error.message) {
        const messageError = (error.code && error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({ messageError });
      } else {
        this.setState({ messageError: I18n.t('errorOcurred') });
      }
    }
    this.setState({ isLoading: false });
  }

  setOnChangeProduct = (value) => {
    this.props.getSearchProducts(10, value, false);
    this.setState({ products: value });
  };

  setOnChangeTypeSolution = async (value) => {
    const typeSolutions = await this.props.getTypeSolutionOptions(value, false);
    this.setState({ listTypeSolutions: typeSolutions, typeSolutions: value });
    if (!value) {
      this.setState({ typeSolutionId: null});
    }
  };

  setOnChangeCableCategory = async (value) => {
    const cableCategories = await this.props.getCableCategoryOptions(value, false);
    this.setState({ listCableCategories: cableCategories, cableCategories: value });
    if (!value) {
      this.setState({ cableCategoryId: null});
    }
  };

  setOnChangeTypeCoating = async (value) => {
    const typeCoatings = await this.props.getTypeCoatingOptions(value, false);
    this.setState({ listTypeCoatings: typeCoatings, typeCoatings: value });
    if (!value) {
      this.setState({ typeCoatingId: null});
    }
  };

  setSelectedProductTelecom = async (selectedProductTelecom) => {
    this.setState({
      editProductTelecom: true,
      id: selectedProductTelecom.id,
      products: `${selectedProductTelecom.product.code} ${selectedProductTelecom.product.description}`,
      product: selectedProductTelecom.product,
      typeSolutions: selectedProductTelecom.typeSolution && selectedProductTelecom.typeSolution.description,
      typeSolutionId: selectedProductTelecom.typeSolution && selectedProductTelecom.typeSolution.id,
      typeCoatings: selectedProductTelecom.typeCoating && selectedProductTelecom.typeCoating.description,
      typeCoatingId: selectedProductTelecom.typeCoating && selectedProductTelecom.typeCoating.id,
      cableCategoryId: selectedProductTelecom.cableCategory && selectedProductTelecom.cableCategory.id,
      cableCategories: selectedProductTelecom.cableCategory && selectedProductTelecom.cableCategory.description,
      formula: selectedProductTelecom.formula,
    });
  }

  setSelectedFieldId = (field, value) => {
    if (field === 'product') {
      this.setState({
        products: value,
        product: { soneparId: selectedHelper.soneparId, code: selectedHelper.code },
      });
    } else if (field === 'typeSolution') {
      this.setState({
        typeSolutions: value,
        typeSolutionId: selectedHelper.id,
      });
    } else if (field === 'cableCategory') {
      this.setState({
        cableCategories: value,
        cableCategoryId: selectedHelper.id,
      });
    } else if (field === 'typeCoating') {
      this.setState({
        typeCoatings: value,
        typeCoatingId: selectedHelper.id,
      });
    }
  };

  setSelectedField = (item) => {
    selectedHelper = item;
    return `${item.code ? `${item.code} ` : ''}${item.description || item.tacTagId.descriptionLarge}`;
  };

  setFormula = (formula) => {    
    this.setState({ formula });
  }

  updateProductTelecom = async () => {
    this.setState({ isLoading: true });
    const {
      id,
      product,
      typeSolutionId,
      typeCoatingId,
      cableCategoryId,
      formula,
    } = this.state;

    if (!product.soneparId || !formula.length) {
      this.setState({ messageError: I18n.t('fieldsNotReported') });
      this.setState({ isLoading: false });
      return;
    }

    try {
      await this.props.updateProductTelecom({
        id,
        productId: product.soneparId,
        typeSolutionId,
        typeCoatingId,
        cableCategoryId,
        formula,
      });

      await this.setState({ messageSuccess: I18n.t('changeMade') });
      await this.goBack();
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;
      this.setState({ messageSuccess: '' });

      if (error && error.message) {
        const messageError = (error.code && error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({ messageError });
      } else {
        this.setState({ messageError: I18n.t('errorOcurred') });
      }
    }
    this.setState({ isLoading: false });
  }

  componentDidMount = async () => {
    if (this.props.back.location.selectedProductTelecom) {
      await this.setSelectedProductTelecom(this.props.back.location.selectedProductTelecom);
    }

    this.props.getSearchProducts(10, '', true);
  
    const typeSolutions = await this.props.getTypeSolutionOptions('', true);
    const cableCategories = await this.props.getCableCategoryOptions('', true);
    const typeCoatings = await this.props.getTypeCoatingOptions('', true);

    this.setState({ 
      isComponentMount: false,
      listTypeSolutions: typeSolutions,
      listCableCategories: cableCategories,
      listTypeCoatings: typeCoatings
    });
  }

  getFormula = () => {
    const { formula } = this.state;
    let stringFormula = '='

    for (const item of formula) {
      if (item.type === 'Product') {
        stringFormula += item.value.code
      } else {
        stringFormula += item.value
      }
    }

    return stringFormula
  }

  render() {
    const {
      products, typeSolutions, cableCategories, typeCoatings, showModal,
      isLoading, messageSuccess, messageError, editProductTelecom, product,
      listTypeSolutions, listCableCategories, listTypeCoatings, formula, isComponentMount,
    } = this.state;
    const {
      searched,
    } = this.props;

    return (
      <div className="form-main">
        <h2 className="header-form-client">
          {I18n.t('productTelecomRegistration')}
        </h2>
        <form>
          <div className="form-group search-custom-input">
            <p className="margin-bottom-2">
              {I18n.t('productCode')} *
            </p>
            <Autocomplete
              getItemValue={item => this.setSelectedField(item)}
              items={searched || []}
              className="custom-select"
              maxLength={FIELDS.max}
              renderItem={(item, isHighlighted) => (
                <div key={item.code} style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                  {item.code}
                  {' '}
                  {item.description}
                  {' '}
                  {item.product.narrativa}
                </div>
              )}
              value={products}
              onChange={e => this.setOnChangeProduct(e.target.value)}
              onSelect={e => this.setSelectedFieldId('product', e)}
            />
          </div>
          <div className="form-group search-custom-input">
            <p className="margin-bottom-2">
              {I18n.t('typeSolution')}
            </p>
            <Autocomplete
              getItemValue={item => this.setSelectedField(item)}
              items={listTypeSolutions || []}
              className="custom-select"
              maxLength={FIELDS.max}
              renderItem={(item, isHighlighted) => (
                <div key={item.description} style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                  {item.description}
                </div>
              )}
              value={typeSolutions || ''}
              onChange={e => this.setOnChangeTypeSolution(e.target.value)}
              onSelect={e => this.setSelectedFieldId('typeSolution', e)}
            />
          </div>
          <div className="form-group search-custom-input">
            <p className="margin-bottom-2">
              {I18n.t('category')}
            </p>
            <Autocomplete
              getItemValue={item => this.setSelectedField(item)}
              items={listCableCategories || []}
              className="custom-select"
              maxLength={FIELDS.max}
              renderItem={(item, isHighlighted) => (
                <div key={item.description} style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                  {item.description}
                </div>
              )}
              value={cableCategories || ''}
              onChange={e => this.setOnChangeCableCategory(e.target.value)}
              onSelect={e => this.setSelectedFieldId('cableCategory', e)}
            />
          </div>
          <div className="form-group search-custom-input">
            <p className="margin-bottom-2">
              {I18n.t('typeCoating')}
            </p>
            <Autocomplete
              getItemValue={item => this.setSelectedField(item)}
              items={listTypeCoatings || []}
              className="custom-select"
              maxLength={FIELDS.max}
              renderItem={(item, isHighlighted) => (
                <div key={item.description} style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                  {item.description}
                </div>
              )}
              value={typeCoatings || ''}
              onChange={e => this.setOnChangeTypeCoating(e.target.value)}
              onSelect={e => this.setSelectedFieldId('typeCoating', e)}
            />
          </div>

          <div className="form-group search-custom-input">
            <p className="margin-bottom-2">
              {I18n.t('formula')} *
            </p>
            <div className="d-flex flex-row">
              <input
                readOnly
                type="text"
                placeholder=""
                value={this.getFormula()}
              />
              <button
                type="button"
                className="btn dark-gray margin-bottom-2 text-light p-l-20 p-r-20 p-b-9 p-t-9"
                onClick={() => this.setState({ showModal: true })}
                disabled={isLoading}
              >
                {I18n.t('edit')}
              </button>
            </div>
          </div>

          {!!messageSuccess && <p className="color-green margin-top-10">{messageSuccess}</p>}
          {!!messageError && <p className="color-red margin-top-10">{messageError}</p>}

          <div className="row margin-left-0 margin-top-20">
            <button
              type="button"
              onClick={() => this.goBack()}
              className="btn btn-warning margin-right-15"
            >
              {I18n.t('return')}
            </button>

            <button
              type="button"
              className="btn btn-dark"
              onClick={() => ((!editProductTelecom) ? this.createProductTelecom() : this.updateProductTelecom())}
              disabled={isLoading}
            >
              {(!editProductTelecom) ? I18n.t('toSend') : I18n.t('resend')}
            </button>
          </div>
        </form>
        {!isComponentMount &&
          <ModalComponent
            id="formula"
            type="formula"
            formula={formula}
            setFormula={this.setFormula}
            productId={product.soneparId}
            visible={showModal}
            size={{ width: '850px', height: '260px' }}
            closeModal={() => this.setState({ showModal: false })}
          />
        }
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getSearchProducts: (limit, search, loading) => {
    dispatch(ProductsAction.searchProductsCheckbuyTelecom(limit, search, loading));
  },
  getTypeSolutionOptions: (search, loading) => dispatch(
    getTypeSolutionOptions(search, loading),
  ),
  getTypeCoatingOptions: (search, loading) => dispatch(
    getTypeCoatingOptions(search, loading),
  ),
  getCableCategoryOptions: (search, loading) => dispatch(
    getCableCategoryOptions(search, loading),
  ),
  createProductTelecom: newProductTelecom => dispatch(createProductTelecom(newProductTelecom)),
  updateProductTelecom: updProductTelecom => dispatch(updateProductTelecom(updProductTelecom)),
});

const mapStateToProps = state => ({
  searched: state.products.productsCheckbuy,
});


export default connect(mapStateToProps, mapDispatchToProps)(ProductTelecomForm);
